module.exports = __webpack_public_path__ + "static/media/left-arrow-disabled.3e2b2b22.svg";